(function() {
    angular.module('tmx-app').controller('advanceSummaryReportCtrl', [
        '$mdSidenav',
        'tmxUtility',
        'menu',
        '$mdMedia',
        'ReportService',
        'resolvedData',

        function advanceSummaryReportCtrl(
            $mdSidenav,
            tmxUtility,
            menu,
            $mdMedia,
            ReportService,
            resolvedData
        ) {
            var advanceSummaryReportVM = this;
            advanceSummaryReportVM.menu = menu;
            advanceSummaryReportVM.gridData = new kendo.data.ObservableArray([]);
            advanceSummaryReportVM.search = search;
            advanceSummaryReportVM.toggle = toggle;
            advanceSummaryReportVM.isOpen = isOpen;
            advanceSummaryReportVM.SAStatuses=[{HiddenValue: -1, VisibleValue: "All"}];
            advanceSummaryReportVM.Organizations= [{HiddenValue: -1, VisibleValue: "All"} ];
            advanceSummaryReportVM.clear = clear;
            advanceSummaryReportVM.formatColumnName = tmxUtility.formatColumnName;
            advanceSummaryReportVM.formatAmount= tmxUtility.formatAmount;
            advanceSummaryReportVM.formatDateTime=function(date){
                if(tmxUtility.exists(date)){
                    date= tmxUtility.formatDateTimeForCompany(date)
                    date= date.split(' ');
                    return date[0]+' '+date[1]+' '+date[2];
                }
                    
                return 'N/A';
            };

            (function InitializePage() {
                if (tmxUtility.exists(resolvedData)) {
                    advanceSummaryReportVM.SAStatuses.push(...resolvedData.SAStatuses.map(x => { return { HiddenValue: x.LookupId, VisibleValue: x.VisibleValue } }));
                    var orgs=resolvedData.Organizations.Data.map(x => { return { HiddenValue: x.OrganizationId, VisibleValue: x.OrganizationName } });
                    advanceSummaryReportVM.Organizations.push(...orgs);
                }
            })();

            function isOpen(navID) {
                return $mdSidenav(navID).isOpen();
            }

            function clear() {
                advanceSummaryReportVM.ToDate = undefined;
                advanceSummaryReportVM.FromDate = undefined;
                advanceSummaryReportVM.StatusId=undefined;
                advanceSummaryReportVM.OrgId=undefined;
                advanceSummaryReportVM.NationalIdentifier=undefined;


            }


            function toggle() {
                $mdSidenav("ExportSideNav")
                    .toggle()
                    .then(function() {});
            }

            advanceSummaryReportVM.exportToPdf = exportToPdf;

            function search() {
                advanceSummaryReportVM.container.advanceSummaryReport.dataSource.read();
                
            }

            function exportToPdf() {

                   
                ReportService.ReportPDF({ StoredProcedure: 'sp-advance-summary-report', ReportName: 'Advance_Summary_Report', Orientation: 'Portrait', 
                    Arguments: { StartDate:advanceSummaryReportVM.FromDate,
                        EndDate:advanceSummaryReportVM.ToDate,
                        OrganizationId: advanceSummaryReportVM.OrgId>0 ? advanceSummaryReportVM.OrgId : undefined ,
                        StatusLkp : advanceSummaryReportVM.StatusId>0 ? advanceSummaryReportVM.StatusId : undefined ,
                        NationalIdentifier: tmxUtility.exists(advanceSummaryReportVM.NationalIdentifier) ? advanceSummaryReportVM.NationalIdentifier :undefined, } });
              
            }


            var gridColumns = [{
                field: tmxUtility.formatColumnName('SmartAdvanceId'),
                title: "Advance No",
                type: "text",
                scrollable: false,
                search: true,
                template: "<div class='tmx-primary-text-grid' style='margin-top: 2px !important;margin-left: -4px;'> {{dataItem.SmartAdvanceId}} </div> <div class='margin-bottom-4'><span class='chip' ng-style={{dataItem.StatusBKColor}}> {{dataItem.Status}}</span> </div> ",
                headerTemplate: "<span>Advance No</span>"
            },
            {
                field: tmxUtility.formatColumnName('NationalIdentifierValue'),
                title: "ID  Number",
                type: "text",
                scrollable: false,
                search: true,
                headerTemplate: "<span>ID Number</span>"
            },
            {
                field: tmxUtility.formatColumnName('CustomerName'),
                title: "Account Title",
                type: "text",
                scrollable: false,
                search: true,
                template: "<div> {{dataItem.CustomerName | defaultValue}}</div><span style='margin-left: 0px;' class='subtitle'>{{dataItem.BranchCode}}</span><span style='margin-left: 0px;' class='subtitle'> - {{dataItem.BankAccountNumber }}</span>", 
                headerTemplate: "<span>Account Details</span>"
            },
            {
                field: tmxUtility.formatColumnName('BankAccountNumber'),
                title: "Bank Account Number",
                type: "text",
                hidden:true,
                scrollable: false,
                search: true,
                headerTemplate: "<span>Account No</span>"
            },
            {
                field: tmxUtility.formatColumnName('BranchCode'),
                title: "Branch Code",
                type: "text",
                hidden:true,
                scrollable: false,
                search: true,
                headerTemplate: "<span>Branch Code</span>"
            },
            {
                field: tmxUtility.formatColumnName('OrganizationName'),
                title: "Organization Name",
                type: "text",
                scrollable: false,
                search: true,
                headerTemplate: "<span>Organization Name</span>"
            },
            {
                field: tmxUtility.formatColumnName('Date'),
                title: "Loan Date",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{AdvanceSummaryReportCtrl.formatDateTime(dataItem[AdvanceSummaryReportCtrl.formatColumnName('Date')])}}",
                headerTemplate: "<span>Loan Date</span>"
            },
            {
                field: tmxUtility.formatColumnName('AdvanceAmount'),
                title: "Loan Amount",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{AdvanceSummaryReportCtrl.formatAmount(dataItem[AdvanceSummaryReportCtrl.formatColumnName('AdvanceAmount')])}}",
                headerTemplate: "<span>Loan Amount</span>"
            },
            {
                field: tmxUtility.formatColumnName('ExpectedRecoveryDate'),
                title: "Maturity Date",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{AdvanceSummaryReportCtrl.formatDateTime(dataItem[AdvanceSummaryReportCtrl.formatColumnName('ExpectedRecoveryDate')])}}",
                headerTemplate: "<span>Maturity Date</span>"
            },
            {
                field: tmxUtility.formatColumnName('Status'),
                title: "Status",
                type: "text",
                scrollable: false,
                search: true,
                hidden:true,
                headerTemplate: "<span>Status</span>"
            },
            {
                field: tmxUtility.formatColumnName('RecoveryDate'),
                title: "Recovery Date",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{AdvanceSummaryReportCtrl.formatDateTime(dataItem[AdvanceSummaryReportCtrl.formatColumnName('RecoveryDate')])}}",
                headerTemplate: "<span>Recovery Date</span>"
            },
            {
                field: tmxUtility.formatColumnName('ServiceFees'),
                title: "Service Fees",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{AdvanceSummaryReportCtrl.formatAmount(dataItem[AdvanceSummaryReportCtrl.formatColumnName('ServiceFees')])}}",
                headerTemplate: "<span>Service Fees</span>"
            },
            {
                field: tmxUtility.formatColumnName('PenaltyCharges'),
                title: "Penalty Fees",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{AdvanceSummaryReportCtrl.formatAmount(dataItem[AdvanceSummaryReportCtrl.formatColumnName('PenaltyCharges')])}}",
                headerTemplate: "<span>Penalty Fees</span>"
            },
            {
                field: tmxUtility.formatColumnName('FeeTechlogix'),
                title: "Techlogix Fee",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{AdvanceSummaryReportCtrl.formatAmount(dataItem[AdvanceSummaryReportCtrl.formatColumnName('FeeTechlogix')])}}",
                headerTemplate: "<span>Techlogix Fee</span>"
            },
            {
                field: tmxUtility.formatColumnName('FedGl'),
                title: "Fed Fee",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{AdvanceSummaryReportCtrl.formatAmount(dataItem[AdvanceSummaryReportCtrl.formatColumnName('FedGl')])}}",
                headerTemplate: "<span>Fed Fee</span>"
            },
            {
                field: tmxUtility.formatColumnName('BankGl'),
                title: "Bank Fee",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{AdvanceSummaryReportCtrl.formatAmount(dataItem[AdvanceSummaryReportCtrl.formatColumnName('BankGl')])}}",
                headerTemplate: "<span>Bank Fee</span>"
            },
            {
                field: tmxUtility.formatColumnName('BalanceAmount'),
                title: "Balance Amount",
                type: "text",
                scrollable: false,
                search: true,
                template: "{{AdvanceSummaryReportCtrl.formatAmount(dataItem[AdvanceSummaryReportCtrl.formatColumnName('BalanceAmount')])}}",
                headerTemplate: "<span>Balance Amount</span>"
            },
                
            ];
            function parseAndResppnse(data){
                data.forEach(function(dataItem){                                                        
                    dataItem.StatusBKColor=tmxUtility.SetStatusBackgroundColor(dataItem.Status);  
                });
                advanceSummaryReportVM.GridResponseData = data;
                                            
            }

            advanceSummaryReportVM.mainGridOptions = {
                autoBind:false,
                dataSource: {
                    transport: {
                        read: function(o) {
                            
                            var objArgs = {
                                StartDate:advanceSummaryReportVM.FromDate,
                                EndDate:advanceSummaryReportVM.ToDate,
                                OrganizationId: advanceSummaryReportVM.OrgId>0 ? advanceSummaryReportVM.OrgId : undefined ,
                                StatusLkp : advanceSummaryReportVM.StatusId>0 ? advanceSummaryReportVM.StatusId : undefined ,
                                NationalIdentifier: tmxUtility.exists(advanceSummaryReportVM.NationalIdentifier) ? advanceSummaryReportVM.NationalIdentifier :undefined,
                                
                            }; 

                            var filters = {
                                "StoredProcedure": "sp-advance-summary-report",
                                "Arguments": objArgs,
                                "ReportName": "Advance_Summary_Report"
                            };

                            firebase.logTmxEvent('report', { name: 'Advance Summary Report' });
                            ReportService.putByParams(o, true, "ReportDataSourceResultPost", filters).then(function(response) {

                                if (response) {
                                    parseAndResppnse(response.data);
                                    //advanceSummaryReportVM.GridResponseData = response.Data;
                                    o.success(response);
                                }
                            });
                            
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "data.length",
                    },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false
                },
                pageable: {
                    refresh: true,
                    pageSizes: [5, 10, 15, 20, 100, "All"],
                    pageSize: 20,
                    buttonCount: 4
                },
                excel: {
                    allPages: true,
                    fileName: "AdvanceSummaryReport.xlsx"
                },
                excelExport: function(e) {
                    var sheet = e.workbook.sheets[0];
                    var data = advanceSummaryReportVM.GridResponseData;
                    var gridColumns = advanceSummaryReportVM.container.advanceSummaryReport.columns;                                      
                    var columns = tmxUtility.columnsMapping(gridColumns);                    
                    var rows=tmxUtility.dataMapping(data,columns);                                                             
                    sheet.rows = rows;  
                
                },
                sortable: true,
                scrollable: !$mdMedia("gt-sm"),

                columns: gridColumns
            };

            
        }
    ]);
})();